import React from 'react';
import clsx from 'clsx';
import { EditableInfo } from '@icoach/components';

const MarketingBox = ({ className, hasMarketing, onEdit }) => {
    return (
        <EditableInfo label="行銷設定" onEdit={onEdit} className={className} isEdit>
            <span className={clsx('marketing-status', !hasMarketing && 'marketing-status--reject')}>
                {hasMarketing ? '接受行銷' : '拒絕行銷'}
            </span>
        </EditableInfo>
    );
};

export default MarketingBox;